import { Sidebar, type SidebarProps } from './component'
import { createSidebarStore } from './store'

// Create singleton store instance to prevent re-creating on every render
export const sidebarStore = createSidebarStore()

type Props = Omit<SidebarProps, 'store'>
export default function Main(props: Props) {
	return <Sidebar store={sidebarStore} {...props} />
}
